import * as React from "react";
import { IconProps } from "./IconProps";

export const IconSolidChevronUp = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="12"
        height="6"
        viewBox="0 0 12 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M10.7929 6C11.2384 6 11.4615 5.46143 11.1465 5.14645L6.3536 0.353547C6.15834 0.158285 5.84175 0.158285 5.64649 0.353547L0.85359 5.14645C0.538608 5.46143 0.761691 6 1.20714 6L10.7929 6Z"
          fill={color}
        />
      </svg>
    );
  },
);
